import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidSentenceReading } from '../../../../mechanics/rid-sentence-reading/rid-sentence-reading';
import { injectQueryParams } from '../../../../utils/route.utils';

@Component({
  selector: 'app-sentence-reading-page',
  imports: [RidSentenceReading],
  templateUrl: './sentence-reading-page.html',
})
export class SentenceReadingPage {
  protected readonly $router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly pace = computed(() => parseInt(this.queryParams()['pace'] ?? '200'));
}
